export const notifications = {
	export: {
		successNotification: "Produits exportés vers Excel",
		errorNotification: "Erreur lors de l'exportation des produits vers Excel",
	},
	productToggle: {
		successActivated: "Le produit {{productName}} a été activé avec succès",
		successDeactivated: "Le produit {{productName}} a été désactivé avec succès",
	},
	massActions: {
		successActivated: "Produits activés avec succès",
		successDeactivated: "Produits désactivés avec succès",
		successEdited: "Produits modifiés avec succès",
		errorEdited: "Erreur lors de la modification des produits",
		noChanges: "Sélectionnez au moins un champ pour enregistrer les modifications",
	},
	categoryNotFound:
		"Catégorie introuvable. Redirection vers la première catégorie disponible.",
};
